import '@emotion/react';
import styled from '@emotion/styled';
import tokens from '@lacedltd/design-tokens';
import { mediaQuery } from '../../../helpers/media.js';

var _a;
var ContentContainer = styled.div((_a = {
        backgroundColor: tokens.color.yeezy[0]
    },
    _a[mediaQuery.m.min] = {
        maxWidth: "".concat(540 / 16, "rem"),
        maxHeight: "".concat(800 / 16, "rem"),
    },
    _a));

export { ContentContainer };
//# sourceMappingURL=CookieBanner.styles.js.map
